import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GatewayDTO } from '../../../../core/models/gateway';

@Component({
  selector: 'app-update-gateway',
  templateUrl: './update-gateway.component.html',
  styleUrls: ['./update-gateway.component.scss']
})
export class UpdateGatewayComponent implements OnInit {
  editGatewayForm: UntypedFormGroup = new UntypedFormGroup({
    editGatewayName: new UntypedFormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z_0-9-]*$/)]),
    editGatewayIP: new UntypedFormControl('', [Validators.required, Validators.pattern('(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)')]),
    editGatewayPort: new UntypedFormControl('', [Validators.required, Validators.pattern(/^[0-9]*$/)]),
  });

  constructor(@Inject(MAT_DIALOG_DATA) public data: { olgGw: GatewayDTO },
    public dialog: MatDialogRef<UpdateGatewayComponent>) { }

  ngOnInit(): void {
    if (this.data?.olgGw) {
      this.editGatewayForm.patchValue({
        editGatewayName: this.data.olgGw.name,
        editGatewayIP: this.data.olgGw.ip,
        editGatewayPort: this.data.olgGw.port
      });
    }
  }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit(form) {
    if (!form.valid) {
      return;
    } else {
      let gw: GatewayDTO = {
        name: form.value.editGatewayName,
        ip: form.value.editGatewayIP,
        port: form.value.editGatewayPort
      }
      this.dialog.close(gw);
    }
  }
}
